import { Slice, Fragment } from 'prosemirror-model';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import intermoji from '@intercom/intermoji';
export default function transformPastedText(text, composer, $context) {
  // Windows uses \r\n as the newline vs just \n in other platforms
  // remove the \r to makes sure when we split on \n we don't leave
  // them dangling
  text = text.replace(/\r/g, '');
  if ($context.parent.type === composer.schema.nodes.codeBlock) {
    return handlePasteTextIntoCodeBlock(text, composer.schema);
  } else {
    return handlePasteText(text, composer.schema);
  }
}
function handlePasteTextIntoCodeBlock(text, schema) {
  let content = [];
  text.split('\n').forEach(s => {
    if (s.length > 0) {
      content.push(schema.text(s));
    }
    content.push(schema.nodes.hardBreak.createAndFill());
  });
  content.pop();
  let pre = schema.nodes.codeBlock.createAndFill({}, content);
  return new Slice(Fragment.fromArray([pre]), 0, 0);
}
function handlePasteText(text, schema) {
  console.debug('TEXT', text);
  let content = [];
  text.split('\n').forEach(s => {
    if (s.length > 0) {
      let textNodes = processMarkdownSyntax(intermoji.substituteUnicodeForColonified(s), schema);
      let accumulatedNodes = [];

      // We want all text either side of any images to be in a paragraph together.
      // To do this, we collect up all other nodes until we reach an image node, at which point we create a paragraph node from them and push it onto `content`.
      // We then push the image node into the `content` array and continue iterating through the remaining nodes in the same way.
      // We continue accumulating non-image nodes until the loop finishes, then create a final paragraph and push onto `content` if there are any more `accumulatedNodes`.
      textNodes.forEach(node => {
        if (node.type.name !== 'image') {
          accumulatedNodes.push(node);
        } else {
          if (accumulatedNodes.length > 0) {
            content.push(schema.nodes.paragraph.createAndFill({}, accumulatedNodes));
            accumulatedNodes = [];
          }
          content.push(node);
        }
      });
      if (accumulatedNodes.length > 0) {
        content.push(schema.nodes.paragraph.createAndFill({}, accumulatedNodes));
        accumulatedNodes = [];
      }
    } else {
      content.push(schema.nodes.paragraph.createAndFill());
    }
  });
  return new Slice(Fragment.fromArray(content), 0, 0);
}
function processMarkdownSyntax(text, schema) {
  // Split text by markdown anchors.
  // E.g. ["some text", " ", "[a link](https://somewhere.com)", " ", "more text"]
  let splitText = text.split(/(^|\s)(\[.+?\]\(.+?\))/g);
  return splitText.reduce((acc, text) => {
    if (text) {
      // Find markdown anchors and replace them with the link text with an anchor mark with the href
      let markdownAnchorMatch = text.match(/^\[(.+?)\]\((.+?)(?:\s.*?)?\)$/);
      if (markdownAnchorMatch) {
        let linkText = markdownAnchorMatch[1];
        let href = markdownAnchorMatch[2];
        return [...acc, schema.text(linkText, [schema.marks.anchor.create({
          href
        })])];
      }

      // Find markdown images and replace with an image node using the passed alt text and URL (match[1] and match[2] respectively)
      let markdownImageMatch = text.match(/(?:[\s\S])?^\!\[(.+?)\]\((.+?)(?:\s.*?)?\)/);
      if (markdownImageMatch) {
        let altText = markdownImageMatch[1];
        let url = markdownImageMatch[2];
        let imageNode = schema.nodes.image.create({
          src: url,
          linkUrl: url,
          text: altText
        });

        // There might be text after the image; we need to create a paragraph node for it
        let imageEndsAt = markdownImageMatch[0].length;
        let trailingText = text.substring(imageEndsAt).trim();
        if (trailingText !== '') {
          return [...acc, imageNode, schema.text(trailingText)];
        } else {
          return [...acc, imageNode];
        }
      }
      return [...acc, schema.text(text)];
    }
    return acc;
  }, []);
}